import { Box, Checkbox, FormControlLabel, FormGroup, FormLabel, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import { useRefData } from '../../../hooks/data/useRefData'
import { setDirtyForm } from '../../../services/appPreferences/dirtyFormStorage'

const CheckBoxGroupWrapper = ({ control, formField, rules, groupIndex, readOnly }) => {
  const hasDefaultOptions = Boolean(formField.defaultOptions?.length)
  const { data: refDataOptions } = useRefData(hasDefaultOptions ? undefined : formField.refDataKey)
  const options = hasDefaultOptions ? formField.defaultOptions : refDataOptions

  return (
    options && (
      <Box sx={{ display: 'flex', flexGrow: 0, flexDirection: 'column' }}>
        <FormLabel id={formField.name}>
          <Typography variant="label">{formField.placeholder}</Typography>
        </FormLabel>
        <Controller
          control={control}
          defaultValue={[0]}
          name={`${formField.name}${groupIndex ? `-${groupIndex}` : ''}`}
          render={({ field }) => (
            <FormGroup row={formField.direction === 'row'}>
              {options.map(option => (
                <FormControlLabel
                  key={option.id}
                  control={
                    <Checkbox
                      checked={field.value.includes(option.id)}
                      onChange={(evt, value) => {
                        if (!readOnly) setDirtyForm(true)
                        if (!value.length) field.onChange([option.id])
                        if (value) {
                          const fieldValue = field.value
                          fieldValue.push(option.id)
                          field.onChange(fieldValue)
                        } else {
                          const fieldValue = field.value.filter(v => v !== option.id)
                          field.onChange(fieldValue)
                        }
                      }}
                    />
                  }
                  disabled={readOnly}
                  label={option.es_AR}
                />
              ))}
            </FormGroup>
          )}
          rules={rules}
        />
      </Box>
    )
  )
}

export default CheckBoxGroupWrapper
